var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("SeaExport.BookingAudit"),
        width: "620px",
        "custom-class": "cargo-form-dialog",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        },
        close: _vm.handleClose
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "cargo-form",
          attrs: { "label-width": "100px", "label-position": "left" }
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { "label-width": "0" }
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { no: "1" },
                          model: {
                            value: _vm.radioType,
                            callback: function($$v) {
                              _vm.radioType = $$v
                            },
                            expression: "radioType"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v(_vm._s(_vm.$t("SeaExport.UseThisNo")))
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm.isDifferentJobOrBusinessFieldValues
            ? _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "auto-width",
                          attrs: { "label-width": "0" }
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-warning",
                            staticStyle: {
                              color: "#e6a23c",
                              "margin-left": "5px"
                            }
                          }),
                          _c("span", { staticStyle: { "font-size": "12px" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "Message.DifferentJobOrBusinessFieldValues"
                                )
                              )
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("SeaExport.OperationCompany")) + "："
                          )
                        ]
                      ),
                      _c("cargo-office-select", {
                        attrs: {
                          no: "2",
                          clearable: false,
                          "have-hq": false,
                          disabled: _vm.isTrustFrom,
                          "office-id": Number(_vm.job.opOffice),
                          "tag-name": "code",
                          tooltip: ""
                        },
                        on: {
                          change: function(p) {
                            _vm.job.opOffice = p.value
                            _vm.officeChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Operation") + "：" } },
                    [
                      _c("cargo-user-select", {
                        attrs: {
                          no: "3",
                          placeholder: _vm.differentForm.op
                            ? _vm.$t("CargoMsg.Cargo_keyWordsTip")
                            : _vm.$t("Message.PreserveOriginalValue") +
                              _vm.$t("SeaExport.Operation"),
                          "method-params": {
                            officeId: _vm.job.opOffice,
                            category: "role",
                            shape: "op"
                          },
                          "default-value": _vm.job.op || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.job.op = p.value
                            _vm.differentForm.op = true
                            _vm.opChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          class: _vm.isBatchUpdate ? "" : "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("SeaExport.OperationDepartment")) +
                              "："
                          )
                        ]
                      ),
                      _c("cargo-department-select", {
                        attrs: {
                          no: "4",
                          placeholder: _vm.differentForm.opDepartment
                            ? _vm.$t("CargoMsg.Cargo_keyWordsTip")
                            : _vm.$t("Message.PreserveOriginalValue") +
                              _vm.$t("SeaExport.OperationDepartment"),
                          "office-id":
                            Number(_vm.job.opOffice) ||
                            _vm.$store.getters.currentOfficeId,
                          "department-id": Number(_vm.job.opDepartment)
                        },
                        on: {
                          change: function(p) {
                            _vm.job.opDepartment = p.value
                            _vm.differentForm.opDepartment = true
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.CustomerService") + "："
                      }
                    },
                    [
                      _c("cargo-user-select", {
                        ref: "csr",
                        attrs: {
                          no: "5",
                          placeholder: _vm.differentForm.csr
                            ? _vm.$t("CargoMsg.Cargo_keyWordsTip")
                            : _vm.$t("Message.PreserveOriginalValue") +
                              _vm.$t("SeaExport.CustomerService"),
                          "method-params": {
                            officeId:
                              _vm.isTrustFrom || _vm.job.salesOffice === 1
                                ? _vm.job.opOffice
                                : _vm.job.salesOffice,
                            category: "role",
                            shape: "csr"
                          },
                          "default-value": _vm.job.csr || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.job.csr = p.value
                            _vm.differentForm.csr = true
                            _vm.csrChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Documents") + "：" } },
                    [
                      _c("cargo-user-select", {
                        ref: "dc",
                        attrs: {
                          no: "6",
                          placeholder: _vm.differentForm.dc
                            ? _vm.$t("CargoMsg.Cargo_keyWordsTip")
                            : _vm.$t("Message.PreserveOriginalValue") +
                              _vm.$t("SeaExport.Documents"),
                          "method-params": {
                            officeId: _vm.job.opOffice,
                            category: "role",
                            shape: "doc"
                          },
                          "default-value": _vm.job.dc || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.job.dc = p.value
                            _vm.differentForm.dc = true
                            _vm.dcChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isAddUserDefinedRoles,
                          expression: "isAddUserDefinedRoles"
                        }
                      ],
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_userDefinedRole1") + "："
                      }
                    },
                    [
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId1",
                        attrs: {
                          no: "24",
                          placeholder: _vm.differentForm.userDefinedRoleId1
                            ? _vm.$t("CargoMsg.Cargo_keyWordsTip")
                            : _vm.$t("Message.PreserveOriginalValue") +
                              _vm.$t("CargoMsg.Cargo_userDefinedRole1"),
                          "method-params": {
                            officeId: _vm.job.opOffice,
                            category: "role",
                            shape: "userDefinedRole1"
                          },
                          "default-value": _vm.job.userDefinedRoleId1 || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.job.userDefinedRoleId1 = p.value
                            _vm.differentForm.userDefinedRoleId1 = true
                            _vm.userDefinedRole1ChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isAddUserDefinedRoles,
                          expression: "isAddUserDefinedRoles"
                        }
                      ],
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_userDefinedRole2") + "："
                      }
                    },
                    [
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId2",
                        attrs: {
                          no: "25",
                          placeholder: _vm.differentForm.userDefinedRoleId2
                            ? _vm.$t("CargoMsg.Cargo_keyWordsTip")
                            : _vm.$t("Message.PreserveOriginalValue") +
                              _vm.$t("CargoMsg.Cargo_userDefinedRole2"),
                          "method-params": {
                            officeId: _vm.job.opOffice,
                            category: "role",
                            shape: "userDefinedRole2"
                          },
                          "default-value": _vm.job.userDefinedRoleId2 || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.job.userDefinedRoleId2 = p.value
                            _vm.differentForm.userDefinedRoleId2 = true
                            _vm.userDefinedRole2ChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.ContractRateProperty") + "："
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            no: "7",
                            placeholder: _vm.differentForm.bookingTerm
                              ? _vm.$t("SeaExport.PleaseSelect")
                              : _vm.$t("Message.PreserveOriginalValue") +
                                _vm.$t("SeaExport.ContractRateProperty"),
                            clearable: false,
                            size: "mini"
                          },
                          on: {
                            change: function(p) {
                              _vm.differentForm.bookingTerm = true
                              _vm.bookingTermChangeHandler(p)
                            }
                          },
                          model: {
                            value: _vm.job.bookingTerm,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "bookingTerm", $$v)
                            },
                            expression: "job.bookingTerm"
                          }
                        },
                        _vm._l(_vm.bookingTerms, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "red-input",
                      attrs: { label: _vm.$t("SeaExport.BookingAgent") + "：" }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "8",
                          placeholder: _vm.differentForm.bookingAgent
                            ? _vm.$t("CargoMsg.Cargo_keyWordsTip")
                            : _vm.$t("Message.PreserveOriginalValue") +
                              _vm.$t("SeaExport.BookingAgent"),
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          filterable: "",
                          "method-params": {
                            bookingAgent: true,
                            companyLob: "seaExport",
                            active: true
                          },
                          "default-value": _vm.job.bookingAgent || ""
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.bookingAgent = p.value
                            _vm.differentForm.bookingAgent = true
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c("b", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(
                          _vm._s(_vm.$t("SeaExport.ShippingCompany") + "：")
                        )
                      ]),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "9",
                          disabled: !_vm.isSameVesselAndFlight,
                          filterable: "",
                          "select-type": _vm.TYPE_NAMES.basic_data_Company,
                          "method-params": {
                            seaCmp: true,
                            companyLob: "seaExport",
                            active: true
                          },
                          "default-value": _vm.isSameVesselAndFlight
                            ? _vm.job.carrierId || ""
                            : "",
                          placeholder: _vm.differentForm.carrierId
                            ? " "
                            : _vm.$t("Message.PreserveOriginalValue") +
                              _vm.$t("SeaExport.ShippingCompany")
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.carrierId = p.value
                            _vm.differentForm.carrierId = true
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c("b", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.Vessel") + "："))
                      ]),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "10",
                          disabled: !_vm.isSameVesselAndFlight,
                          "select-type": _vm.TYPE_NAMES.static_data_Vessel,
                          cache: false,
                          filterable: "",
                          "allow-create": _vm.allowEditingVessel,
                          "default-value": _vm.isSameVesselAndFlight
                            ? _vm.job.vessel
                            : "",
                          "static-options": _vm.vesselList,
                          placeholder: _vm.differentForm.vessel
                            ? " "
                            : _vm.$t("Message.PreserveOriginalValue") +
                              _vm.$t("SeaExport.Vessel")
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.differentForm.vessel = true
                            _vm.onVesselSelectionChange(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c("b", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.Voyage") + "："))
                      ]),
                      _c("cargo-advance-select", {
                        ref: "voyageFlight",
                        attrs: {
                          no: "11",
                          disabled: !_vm.isSameVesselAndFlight,
                          cache: false,
                          filterable: "",
                          clearable: "",
                          "allow-create": _vm.allowEditingVoyageFlight,
                          "default-value": _vm.isSameVesselAndFlight
                            ? _vm.job.voyageFlight
                            : "",
                          "tag-name": "voyageNo",
                          "tag-value": "voyageNo",
                          "static-options": _vm.voyages,
                          placeholder: _vm.differentForm.voyageFlight
                            ? " "
                            : _vm.$t("Message.PreserveOriginalValue") +
                              _vm.$t("SeaExport.Voyage")
                        },
                        on: {
                          focus: _vm.txtVoyageFocusInHandler,
                          parentCallBack: function(p) {
                            _vm.job.voyageFlight = p.value
                            _vm.differentForm.voyageFlight = true
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "IMO" } },
                    [
                      _vm.isSameVesselAndFlight
                        ? _c("el-input", {
                            attrs: {
                              no: "12",
                              placeholder: _vm.differentForm.vesselIMO
                                ? ""
                                : _vm.$t("Message.PreserveOriginalValue") +
                                  "IMO"
                            },
                            on: {
                              change: function(p) {
                                _vm.differentForm.vesselIMO = true
                              }
                            },
                            model: {
                              value: _vm.job.vesselIMO,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "vesselIMO", $$v)
                              },
                              expression: "job.vesselIMO"
                            }
                          })
                        : _c("el-input", {
                            attrs: { no: "13", disabled: true },
                            model: {
                              value: undefined,
                              callback: function($$v) {
                                undefined = $$v
                              },
                              expression: "undefined"
                            }
                          })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c("b", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.ServiceCode") + "："))
                      ]),
                      _vm.isSameVesselAndFlight
                        ? _c("el-input", {
                            attrs: {
                              no: "14",
                              placeholder: _vm.differentForm.vesselLineCode
                                ? ""
                                : _vm.$t("Message.PreserveOriginalValue") +
                                  _vm.$t("SeaExport.ServiceCode")
                            },
                            on: {
                              change: function(p) {
                                _vm.differentForm.vesselLineCode = true
                              }
                            },
                            model: {
                              value: _vm.job.vesselLineCode,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "vesselLineCode", $$v)
                              },
                              expression: "job.vesselLineCode"
                            }
                          })
                        : _c("el-input", {
                            attrs: { no: "15", disabled: true },
                            model: {
                              value: undefined,
                              callback: function($$v) {
                                undefined = $$v
                              },
                              expression: "undefined"
                            }
                          })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isDisplayOP,
                      expression: "isDisplayOP"
                    }
                  ],
                  attrs: { span: 12 }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label:
                          _vm.$t("SeaExport.ShippingCompanyContractNo") + "："
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "16" },
                        model: {
                          value: _vm.job.scNo,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "scNo", $$v)
                          },
                          expression: "job.scNo"
                        }
                      }),
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "26" },
                          model: {
                            value: _vm.AddApproximateSymbolToItemColumn,
                            callback: function($$v) {
                              _vm.AddApproximateSymbolToItemColumn = $$v
                            },
                            expression: "AddApproximateSymbolToItemColumn"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "SeaExport.AddApproximateSymbolToItemColumn"
                              )
                            )
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "N/A：" } },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "17",
                          placeholder: _vm.differentForm.na
                            ? ""
                            : _vm.$t("Message.PreserveOriginalValue") + "N/A"
                        },
                        on: {
                          change: function(p) {
                            _vm.differentForm.na = true
                          }
                        },
                        model: {
                          value: _vm.job.na,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "na", $$v)
                          },
                          expression: "job.na"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "N/A CODE：" } },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "18",
                          placeholder: _vm.differentForm.naCode
                            ? ""
                            : _vm.$t("Message.PreserveOriginalValue") +
                              "N/A CODE"
                        },
                        on: {
                          change: function(p) {
                            _vm.differentForm.naCode = true
                          }
                        },
                        model: {
                          value: _vm.job.naCode,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "naCode", $$v)
                          },
                          expression: "job.naCode"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isDisplayOP,
                  expression: "isDisplayOP"
                }
              ],
              attrs: { gutter: 10 }
            },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "LINE CODE：" } },
                    [
                      _c("el-input", {
                        attrs: { no: "19" },
                        model: {
                          value: _vm.job.laneCode,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "laneCode", $$v)
                          },
                          expression: "job.laneCode"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "CODE：" } },
                    [
                      _c("el-input", {
                        attrs: { no: "20" },
                        model: {
                          value: _vm.job.subContractNo,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "subContractNo", $$v)
                          },
                          expression: "job.subContractNo"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Remarks") + "：" } },
                    [
                      _c("el-input", {
                        attrs: { no: "21", type: "textarea", rows: 2 },
                        model: {
                          value: _vm.bookingAuditRemark,
                          callback: function($$v) {
                            _vm.bookingAuditRemark = $$v
                          },
                          expression: "bookingAuditRemark"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-checkbox",
                    {
                      staticStyle: { "margin-left": "100px" },
                      attrs: { no: "24" },
                      model: {
                        value: _vm.overwriteOriginalRemarkFlag,
                        callback: function($$v) {
                          _vm.overwriteOriginalRemarkFlag = $$v
                        },
                        expression: "overwriteOriginalRemarkFlag"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("SeaExport.OverwriteOriginalRemark"))
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "span",
        {
          staticStyle: { padding: "10px" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { no: "22", type: "primary" },
              on: { click: _vm.handleSubmit }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Confirm")))]
          ),
          _c(
            "el-button",
            { attrs: { no: "23" }, on: { click: _vm.handleClose } },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }